import { useTypedParams } from "react-router-typesafe-routes";

import { ResourceGroupNotificationsTable } from "@components/Tables";

import { Box } from "@design-system/Box/Box";

import { PortalHeaderActions } from "@layouts/PortalPage/PortalHeaderActions";

import { routes } from "@pages/routes";

export const ApplicationNotifications = () => {
  const { applicationId } = useTypedParams(
    routes.portal.clients.client.applications.application.notifications,
  );

  return (
    <Box direction="column" fullStretch>
      <PortalHeaderActions>
        <Box direction="row" gap={8} align="center"></Box>
      </PortalHeaderActions>
      <ResourceGroupNotificationsTable
        clientApplicationId={applicationId}
        pageSize={30}
      />
    </Box>
  );
};
